<template>
  <div>
    <div class="page-wrapper">
      <div class="page-content-wrapper">
        <div class="shadow-btm">
          <div class="row">
            <div
              class="col-lg-12 col-sm-12 my-auto d-flex align-items-center mb-4"
            >
              <a
                class="pr-2 text-dark cursor-pointer"
                v-on:click="$router.push('/contact')"
                ><span class="font-24 mr-2"
                  ><img src="/images/back-arrow.svg" width="18"
                /></span>
              </a>
              <h4 class="mb-0 lg-bld">{{ uuid ? "Edit" : "Add" }} Branch</h4>
            </div>
          </div>
        </div>
        <div class="page-content">
          <div class="card-body py-0 px-0">
            <div class="row">
              <div class="col-lg-10 col-sm-10 float-none">
                <div class="card border mb-0 radius-15">
                  <div class="card-body">
                    <Form itemref="adminForm" @submit="save()">
                      <div class="row">
                        <div class="col-lg-6 col-sm-6">
                          <div class="form-group">
                            <label>Branch Name</label>
                            <span class="text-danger">*</span>
                            <Field
                              type="text"
                              name="branch_name"
                              class="form-control"
                              placeholder="Branch Name"
                              v-model="detail.branch_name"
                              rules="required:branch name"
                              :validateOnInput="true"
                            />
                            <ErrorMessage
                              name="branch_name"
                              class="text-danger"
                            />
                          </div>
                        </div>
                        <div class="col-lg-6 col-sm-6">
                          <div class="form-group">
                            <label>Address</label>
                            <span class="text-danger">*</span>
                            <Field
                              type="text"
                              name="address"
                              class="form-control"
                              placeholder="Address"
                              v-model="detail.address"
                              rules="required:address"
                              :validateOnInput="true"
                            />
                            <ErrorMessage name="address" class="text-danger" />
                          </div>
                        </div>
                        <div class="col-lg-6 col-sm-6">
                          <div class="form-group">
                            <label>Email</label>
                            <span class="text-danger">*</span>
                            <Field
                              type="email"
                              name="email"
                              class="form-control"
                              placeholder="Email"
                              v-model="detail.email"
                              rules="required:email|email"
                              :validateOnInput="true"
                            />
                            <ErrorMessage name="email" class="text-danger" />
                          </div>
                        </div>
                        <div class="col-lg-6 col-sm-6">
                          <div class="form-group">
                            <label>Phone no.</label>

                            <Field
                              type="text"
                              name="phone"
                              placeholder="Phone"
                              v-slot="{ field }"
                              v-model="detail.phone"
                              rules=":phone no.|phone"
                              :validateOnInput="true"
                            >
                              <PhoneCode
                                id="mobile"
                                placeholder="Mobile Number"
                                v-model:countryCode="detail.country_code"
                                v-model="detail.phone"
                                v-model:dialCode="detail.mobile_country_code"
                                v-bind="field"
                              />
                              <ErrorMessage name="phone" class="text-danger" />
                            </Field>
                          </div>
                        </div>
                        <div class="col-lg-12 col-sm-12 text-center mt-2">
                          <button id="save-button" class="fill-btn px-4 ml-3">
                            Save
                          </button>
                          <button
                            type="button"
                            class="fil-btn px-4 ml-3"
                            v-on:click="$router.go(-1)"
                            id="cancel-button"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    -->
  </div>
</template>
<script>
// import TextModal from "@/components/TextModal";
import { Form, Field, ErrorMessage } from "vee-validate";
import PhoneCode from "../../components/PhoneCodePicker/PhoneCode.vue";
export default {
  name: "AddContact",
  components: {
    Form,
    Field,
    ErrorMessage,
    // TextModal,
    PhoneCode,
  },
  data() {
    return {
      uuid: this.$route.params.uuid,
      detail: {},
    };
  },
  mounted() {
    this.$helperService.showMenu("true");
    if (this.uuid) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      this.$api
        .getAPI({
          _action: "/contact-us/" + this.uuid,
        })
        .then((res) => {
          this.detail = res;
        })
        .catch(() => {});
    },
    save() {
      if (this.uuid) {
        this.$api
          .putAPI({
            _action: "/contact-us",
            _body: this.detail,
            _buttonId: "save-button",
          })
          .then(() => {
            this.$router.go(-1);
          })
          .catch(() => {});
      } else {
        this.$api
          .postAPI({
            _action: "/contact-us",
            _body: this.detail,
            _buttonId: "save-button",
          })
          .then(() => {
            this.$router.go(-1);
          })
          .catch(() => {});
      }
    },
  },
};
</script>